var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "enroll_tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": _vm.handleClick,
            "tab-remove": _vm.handleTabRemove,
          },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "报名活动", name: "enroll_table" } },
            [
              _c("EnrollTablePane", {
                ref: "enroll_table",
                on: {
                  toEnrollConfig: _vm.handleToEnrollConfig,
                  toEnrollJoin: _vm.handleToEnrollJoin,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showConfigTab
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.isEdit ? "编辑报名活动" : "添加报名活动",
                    name: "enroll_config",
                    closable: true,
                  },
                },
                [
                  _vm.showConfigTab
                    ? _c("EnrollConfigPane", {
                        key: _vm.configKey,
                        attrs: { id: _vm.currentId },
                        on: {
                          success: _vm.handleSuccess,
                          cancel: _vm.handleCancel,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.joinTabs, function (item) {
            return _c(
              "el-tab-pane",
              {
                key: item.name,
                attrs: { label: item.title, name: item.name, closable: true },
              },
              [
                _c("EnrollJoinPane", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName === item.name,
                      expression: "activeName === item.name",
                    },
                  ],
                  ref: item.name,
                  refInFor: true,
                  attrs: {
                    "activity-id": item.activityId,
                    "activity-title": item.activityTitle,
                    "init-filters": item.filters,
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }